let csrfTokenPromise;

const getCsrfTokenPromise = async () => {
	if (!csrfTokenPromise) {
		csrfTokenPromise = fetch(
			`${window.BL.config.slingProxyPrefix || '/'}libs/granite/csrf/token.json`
		).then(response => response.json());

		//setup a timer to delete the token after 5 minutes
		csrfTokenPromise.then(() => setTimeout(() => (csrfTokenPromise = undefined), 5000));
	}

	return csrfTokenPromise;
};

export { getCsrfTokenPromise };
